//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex'

export default {
  name: 'Settings',
  data () {
    return {
    }
  },
  methods: {
    updateSettings (value, event) {
      const newSetting = {
        attribute: event.target.id,
        value: value
      }
      this.setSetting(newSetting)
    },
    ...mapActions('ui', ['setSetting', 'setTitle'])
  },
  computed: {
    ...mapState('ui', {
      getSettings: 'settings'
    }),
    settings () {
      return this.getSettings
    }
  },
  created () {
    this.setTitle('Настройки')
  }
}
